(function () {
  const DEFAULT_LAT = 25.2048;
  const DEFAULT_LNG = 55.2708;
  const STORAGE_KEY = 'med7_location';
  const MAX_LOCATION_AGE_MS = 24 * 60 * 60 * 1000; // stored location trusted for 24h before re-detecting

  const drawer = document.getElementById('geo-drawer');
  const overlay = document.getElementById('geo-drawer-overlay');
  const openBtn = document.getElementById('geolocation-open-drawer');
  const closeBtn = document.getElementById('geolocation-close-drawer');
  const confirmBtn = document.getElementById('geo-confirm-btn');
  const searchInput = document.getElementById('geo-search-input');
  const searchResults = document.getElementById('geo-search-results');
  const barLocation = document.getElementById('geo-bar-location');

  // Current location box (live map pin)
  const currentBox = document.getElementById('geo-current-box');
  const currentName = document.getElementById('geo-current-name');
  const currentAddress = document.getElementById('geo-current-address');

  // "Couldn't detect location" hint (network/browser/permission limitations)
  const locationHint = document.getElementById('geo-location-hint');
  const locationHintText = document.getElementById('geo-location-hint-text');
  const locationHintRetry = document.getElementById('geo-location-hint-retry');

  // On mobile the hint renders as its own box under the drawer header instead
  // of nested inside the "current location" box (desktop keeps it nested).
  const mobileHintAnchor = document.getElementById('geo-mobile-hint-anchor');
  const desktopHintParent = locationHint ? locationHint.parentElement : null;
  const mobileHintQuery = window.matchMedia('(max-width: 768px)');
  function positionLocationHint() {
    if (!locationHint) return;
    var target = mobileHintQuery.matches ? mobileHintAnchor : desktopHintParent;
    if (target && locationHint.parentElement !== target) target.appendChild(locationHint);
    // Re-sync the anchor's own visibility (it only wraps the hint on mobile) in
    // case the viewport crosses the breakpoint while the hint is on screen.
    if (mobileHintAnchor) {
      var isShown = locationHint.style.display === 'flex';
      mobileHintAnchor.style.display = (locationHint.parentElement === mobileHintAnchor && isShown) ? 'block' : 'none';
    }
  }
  positionLocationHint();
  if (mobileHintQuery.addEventListener) mobileHintQuery.addEventListener('change', positionLocationHint);
  else if (mobileHintQuery.addListener) mobileHintQuery.addListener(positionLocationHint); // Safari < 14

  // "Fetching your location from browser..." message shown on the map while
  // navigator.geolocation resolves after a manual "Locate me" click.
  const mapFetchingMsg = document.getElementById('geo-map-fetching-msg');
  function showMapFetchingMsg() {
    if (!mapFetchingMsg) return;
    mapFetchingMsg.textContent = (window.med7GeoStrings && window.med7GeoStrings.fetchingLocation) || 'Fetching your location from browser...';
    mapFetchingMsg.style.display = 'block';
  }
  function hideMapFetchingMsg() {
    if (mapFetchingMsg) mapFetchingMsg.style.display = 'none';
  }

  // Selected location box (confirmed / stored)
  const selectedBox = document.getElementById('geo-selected-box');
  const selectedName = document.getElementById('geo-selected-name');
  const selectedAddress = document.getElementById('geo-selected-address');

  if (!drawer) return; // guard: snippet not on page

  // Move drawer and overlay to document.body so they escape any transformed
  // ancestor (e.g. the theme's scroll-animated sticky header). A CSS
  // position:fixed element inside a transformed parent is positioned relative
  // to that parent, not the viewport — this is what causes the drawer to peek
  // on mobile when the header animates during scroll.
  if (drawer.parentElement !== document.body)   document.body.appendChild(drawer);
  if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);

  // Replace with your MapBox public token — restrict it by domain in the MapBox dashboard.
  const MAPBOX_TOKEN = 'pk.eyJ1IjoibWVkN29ubGluZSIsImEiOiJjbXFxOXp0ZzEwY29yMnJzZnJpcG42OXlmIn0.GSlq05B9inrDRBV2pkK_LQ';

  let map = null;
  let marker = null;
  let mapInitialized = false;
  let mapboxLoaded = false;
  let mapboxLoadPromise = null;
  let searchDebounceTimer = null;
  let searchSessionToken  = null;
  let pendingLocation = null;    // tracks live map pin state
  let confirmedLocation = null;  // tracks last confirmed (stored) state

  // Detection watchdog: navigator.geolocation's own `timeout` option is not
  // honored by every browser/webview, so a JS-level safety timer backs it up.
  const GEO_NATIVE_TIMEOUT_MS = 12000;
  const GEO_SAFETY_TIMEOUT_MS = 15000;
  let geoSettled = true;   // false while a getCurrentPosition() call is in flight
  let geoSafetyTimer = null;

  // ── MapBox GL lazy loader ────────────────────────────────────────────────
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = function () { reject(new Error('Failed to load: ' + src)); };
      document.head.appendChild(s);
    });
  }

  function loadMapbox() {
    if (mapboxLoaded) return Promise.resolve();
    if (mapboxLoadPromise) return mapboxLoadPromise;

    // Inject CSS into <head> first — MapBox markers and controls rely on CSS
    // classes for position:absolute; if the CSS loads after JS the controls
    // fall into normal document flow below the map container.
    if (!document.querySelector('link[href*="mapbox-gl.css"]')) {
      var cssLink = document.createElement('link');
      cssLink.rel = 'stylesheet';
      cssLink.href = 'https://api.mapbox.com/mapbox-gl-js/v3.12.0/mapbox-gl.css';
      document.head.appendChild(cssLink);
    }

    mapboxLoadPromise = loadScript('https://api.mapbox.com/mapbox-gl-js/v3.12.0/mapbox-gl.js')
      .then(function () {
        mapboxgl.accessToken = MAPBOX_TOKEN;
        mapboxLoaded = true;
      })
      .catch(function (err) {
        mapboxLoadPromise = null; // allow retry on next open
        return Promise.reject(err);
      });

    return mapboxLoadPromise;
  }

  // ── Box visibility ───────────────────────────────────────────────────────
  function locationsMatch(a, b) {
    if (!a || !b) return false;
    return Math.round(a.lat * 10000) === Math.round(b.lat * 10000) &&
           Math.round(a.lng * 10000) === Math.round(b.lng * 10000);
  }

  function syncBoxVisibility() {
    const hasConfirmed = !!confirmedLocation;
    const differs = hasConfirmed && !locationsMatch(pendingLocation, confirmedLocation);

    // Current box: visible when no confirmed location exists, or pin has moved away from it
    currentBox.style.display = (!hasConfirmed || differs) ? 'block' : 'none';
    // Selected box: visible only when a confirmed location exists
    selectedBox.style.display = hasConfirmed ? 'block' : 'none';
  }

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  // ── PickyPal chat widget avoidance ────────────────────────────────────────
  // The PickyPal app injects a fixed "Guide me" button in an open shadow root
  // (#pickypal-react-app-root), normally anchored bottom:16px; right:16px.
  // It overlaps this drawer's disclaimer/confirm area, so nudge it clear of the
  // drawer horizontally while the drawer is open and restore it on close.
  // PickyPal is a React app that can reset its own inline style on re-render,
  // so a MutationObserver keeps reapplying the offset for as long as the
  // drawer stays open.
  var PICKYPAL_OFFSET_RIGHT  = '448px';
  var PICKYPAL_TRANSITION_MS = 300;

  var _pickyPalWrapper       = null;
  var _pickyPalOriginalCss   = null;
  var _pickyPalOriginalRight = null;
  var _pickyPalObserver      = null;
  var _pickyPalFindTimer     = null;
  var _pickyPalRestoreTimer  = null;

  function findPickyPalWrapper() {
    var host = document.getElementById('pickypal-react-app-root');
    var root = host && host.shadowRoot;
    if (!root) return null;
    var toggle = root.getElementById ? root.getElementById('chatbot-toggle') : root.querySelector('#chatbot-toggle');
    var el = toggle;
    for (var i = 0; i < 6 && el; i++) {
      if (el.style && el.style.position === 'fixed') return el;
      el = el.parentElement;
    }
    return null;
  }

  function isDesktopViewport() {
    return window.innerWidth > 768;
  }

  function applyPickyPalOffset(el) {
    if (!isDesktopViewport()) return; // drawer is full-width on mobile, no overlap to avoid
    if (_pickyPalOriginalCss === null) {
      _pickyPalOriginalCss   = el.getAttribute('style') || '';
      _pickyPalOriginalRight = el.style.right || '16px';
    }
    if (el.style.getPropertyValue('right') === PICKYPAL_OFFSET_RIGHT && el.style.getPropertyPriority('right') === 'important') return;
    el.style.setProperty('transition', 'right ' + PICKYPAL_TRANSITION_MS + 'ms ease', 'important');
    el.style.setProperty('right', PICKYPAL_OFFSET_RIGHT, 'important');
  }

  function startPickyPalAvoidance() {
    if (_pickyPalRestoreTimer) { clearTimeout(_pickyPalRestoreTimer); _pickyPalRestoreTimer = null; }
    if (_pickyPalFindTimer || _pickyPalWrapper) return;
    _pickyPalFindTimer = setInterval(function () {
      var el = findPickyPalWrapper();
      if (!el) return;
      clearInterval(_pickyPalFindTimer);
      _pickyPalFindTimer = null;
      _pickyPalWrapper = el;
      applyPickyPalOffset(el);
      _pickyPalObserver = new MutationObserver(function () { applyPickyPalOffset(el); });
      _pickyPalObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
    }, 300);
    // Stop trying after 10s if PickyPal never loads (e.g. blocked/absent).
    setTimeout(function () {
      if (_pickyPalFindTimer) { clearInterval(_pickyPalFindTimer); _pickyPalFindTimer = null; }
    }, 10000);
  }

  function stopPickyPalAvoidance() {
    if (_pickyPalFindTimer) { clearInterval(_pickyPalFindTimer); _pickyPalFindTimer = null; }
    if (_pickyPalObserver) { _pickyPalObserver.disconnect(); _pickyPalObserver = null; }

    var el          = _pickyPalWrapper;
    var originalCss = _pickyPalOriginalCss;
    if (el && originalCss !== null) {
      // Animate back to the original position first, then fully restore the
      // original style attribute once the transition finishes so PickyPal's
      // own script/CSS regains full control afterward.
      el.style.setProperty('transition', 'right ' + PICKYPAL_TRANSITION_MS + 'ms ease', 'important');
      el.style.setProperty('right', _pickyPalOriginalRight, 'important');
      _pickyPalRestoreTimer = setTimeout(function () {
        _pickyPalRestoreTimer = null;
        if (_pickyPalWrapper !== el) return; // reclaimed by a newer avoidance session
        el.setAttribute('style', originalCss);
      }, PICKYPAL_TRANSITION_MS + 50);
    }
    _pickyPalWrapper       = null;
    _pickyPalOriginalCss   = null;
    _pickyPalOriginalRight = null;
  }

  // ── Drawer open / close ──────────────────────────────────────────────────
  function openDrawer() {
    searchSessionToken = generateUUID();
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    startPickyPalAvoidance();

    loadMapbox()
      .then(function () {
        if (!mapInitialized) {
          const stored = getStoredLocation();
          const lat = stored ? stored.lat : DEFAULT_LAT;
          const lng = stored ? stored.lng : DEFAULT_LNG;

          initMap(lat, lng);
          mapInitialized = true;

          if (stored) {
            confirmedLocation = stored;
            setConfirmedBox(stored);
            var city    = isArabic() ? (stored.city_ar    || stored.city)    : (stored.city_en    || stored.city);
            var country = isArabic() ? (stored.country_ar || stored.country) : (stored.country_en || stored.country);
            setPendingLocation(stored.lat, stored.lng, stored, city, country);
          } else {
            getCurrentLocation();
          }
        } else {
          map.resize();
        }
      })
      .catch(function () {
        const mapEl = document.getElementById('geo-map');
        if (mapEl) mapEl.textContent = 'Map unavailable. Please search for your location above.';
        if (confirmBtn) confirmBtn.disabled = false;
      });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hideResults();
    hideMapFetchingMsg();
    stopPickyPalAvoidance();
  }

  // ── Map init ─────────────────────────────────────────────────────────────
  function initMap(lat, lng) {
    map = new mapboxgl.Map({
      container: 'geo-map',
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [lng, lat],  // MapBox uses [longitude, latitude]
      zoom: 13,
      attributionControl: false,  // replaced with compact control below
      language: isArabic() ? 'ar' : 'en',
      worldview: 'US'
    });

    // Compact attribution — legally required by MapBox ToS (includes OSM credit)
    map.addControl(new mapboxgl.AttributionControl({ compact: true }), 'bottom-left');

    marker = new mapboxgl.Marker({ draggable: true })
      .setLngLat([lng, lat])
      .addTo(map);

    marker.on('dragend', function () {
      var lngLat = marker.getLngLat();
      reverseGeocode(lngLat.lat, lngLat.lng);
    });

    // "Locate me" — custom MapBox control
    var locateBtn = document.createElement('button');
    locateBtn.type = 'button';
    locateBtn.className = 'geo-locate-btn geo-locate-btn--expanded';
    locateBtn.title = 'Use my current location';
    var locateMeLabel = (window.med7GeoStrings && window.med7GeoStrings.locateMe) || 'Locate me';
    locateBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/><circle cx="12" cy="12" r="9" stroke-dasharray="2 4"/></svg><span class="geo-locate-btn__label">' + locateMeLabel + '</span>';
    locateBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      showMapFetchingMsg();
      getCurrentLocation();
    });

    var locateContainer = document.createElement('div');
    locateContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    locateContainer.appendChild(locateBtn);

    map.addControl({
      onAdd: function () { return locateContainer; },
      onRemove: function () {}
    }, 'bottom-right');

  }

  // ── "Couldn't detect location" hint ──────────────────────────────────────
  function hideLocationHint() {
    if (!locationHint) return;
    locationHint.style.display = 'none';
    if (mobileHintAnchor) mobileHintAnchor.style.display = 'none';
  }

  function showLocationHint(reason) {
    if (!locationHint || !locationHintText) return;
    var strings = window.med7GeoStrings || {};
    var msg = reason === 'permission_denied'
      ? (strings.locationPermissionDeniedMsg || 'Location access is blocked in your browser. Enable it in your browser settings, or search for your address above.')
      : (strings.locationTimeoutMsg || "Unable to detect your location automatically, please check your network or location settings.");
    locationHintText.textContent = msg;
    locationHint.style.display = 'flex';
    if (locationHint.parentElement === mobileHintAnchor) mobileHintAnchor.style.display = 'block';
  }

  // reason: 'timeout' | 'position_unavailable' | 'permission_denied'
  function handleLocationDetectionFailure(reason) {
    if (geoSettled) return; // already resolved via the other path (native vs. safety timer)
    geoSettled = true;
    if (geoSafetyTimer) { clearTimeout(geoSafetyTimer); geoSafetyTimer = null; }
    hideMapFetchingMsg();

    reverseGeocode(DEFAULT_LAT, DEFAULT_LNG);
    showLocationHint(reason);

    window.dispatchEvent(new CustomEvent('med7:location-detection-failed', {
      detail: { reason: reason }
    }));
  }

  // ── Geolocation API ──────────────────────────────────────────────────────
  function getCurrentLocation() {
    hideLocationHint();

    if (!navigator.geolocation) {
      reverseGeocode(DEFAULT_LAT, DEFAULT_LNG);
      return;
    }

    setPendingLocation(DEFAULT_LAT, DEFAULT_LNG, { display_en: '', display_ar: '' }, (window.med7GeoStrings && window.med7GeoStrings.detecting) || 'Detecting…', '', true);

    geoSettled = false;
    if (geoSafetyTimer) clearTimeout(geoSafetyTimer);
    geoSafetyTimer = setTimeout(function () {
      handleLocationDetectionFailure('timeout');
    }, GEO_SAFETY_TIMEOUT_MS);

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        geoSettled = true;
        if (geoSafetyTimer) { clearTimeout(geoSafetyTimer); geoSafetyTimer = null; }
        hideLocationHint();
        hideMapFetchingMsg();

        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;
        map.flyTo({ center: [lng, lat], zoom: 15 });
        marker.setLngLat([lng, lat]);
        reverseGeocode(lat, lng);
      },
      function (error) {
        var reason = error && error.code === 1 ? 'permission_denied'
          : error && error.code === 2 ? 'position_unavailable'
          : 'timeout';
        handleLocationDetectionFailure(reason);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: GEO_NATIVE_TIMEOUT_MS
      }
    );
  }

  function isArabic() {
    var locale = (window.med7GeoStrings && window.med7GeoStrings.locale) || 'en';
    return locale.split('-')[0] === 'ar';
  }

  // ── Reverse geocoding (MapBox Geocoding v6) ──────────────────────────────
  // v6 nests context by level (place/region/country) and — unlike v5's flat
  // {id, text} array — gives region.region_code_full (e.g. "AE-RK"), a stable
  // identifier we can match on instead of free-text region names.
  function fetchAddress(lat, lng, lang) {
    var url = 'https://api.mapbox.com/search/geocode/v6/reverse'
      + '?longitude=' + lng + '&latitude=' + lat
      + '&access_token=' + MAPBOX_TOKEN
      + '&language=' + lang
      + '&limit=1';
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var feature = data.features && data.features[0];
        if (!feature) return { fullAddress: '', city: '', country: '', region: '', regionCode: '' };
        var props = feature.properties || {};
        var ctx = props.context || {};
        var city = (ctx.place && ctx.place.name) || props.name || '';
        var country = (ctx.country && ctx.country.name) || '';
        var region = (ctx.region && ctx.region.name) || '';
        var regionCode = (ctx.region && ctx.region.region_code_full) || '';
        return { fullAddress: props.full_address || '', city: city, country: country, region: region, regionCode: regionCode };
      });
  }

  function reverseGeocode(lat, lng) {
    Promise.all([fetchAddress(lat, lng, 'en'), fetchAddress(lat, lng, 'ar')])
      .then(function (res) {
        var en = res[0], ar = res[1];
        var current = isArabic() ? ar : en;
        setPendingLocation(lat, lng, {
          display_en: en.fullAddress, display_ar: ar.fullAddress,
          city_en: en.city,           city_ar: ar.city,
          country_en: en.country,     country_ar: ar.country,
          city_context_en: en.city,       city_context_ar: ar.city,
          country_context_en: en.country, country_context_ar: ar.country,
          region_context_en: en.region,   region_context_ar: ar.region,
          region_code: en.regionCode || ar.regionCode || ''
        }, current.city, current.country);
      })
      .catch(function () {
        setPendingLocation(lat, lng, {
          display_en: 'Dubai, United Arab Emirates',
          display_ar: 'دبي، الإمارات العربية المتحدة',
          city_en: 'Dubai',           city_ar: 'دبي',
          country_en: 'United Arab Emirates', country_ar: 'الإمارات العربية المتحدة',
          city_context_en: 'Dubai',           city_context_ar: 'دبي',
          country_context_en: 'United Arab Emirates', country_context_ar: 'الإمارات العربية المتحدة',
          region_context_en: 'Dubai',         region_context_ar: 'دبي',
          region_code: 'AE-DU'
        }, isArabic() ? 'دبي' : 'Dubai', isArabic() ? 'الإمارات العربية المتحدة' : 'United Arab Emirates');
      });
  }

  // ── Search Box API: /suggest + /retrieve ────────────────────────────────
  function getProximity() {
    // Bias suggestions toward the user's current pin or stored location
    var loc = (pendingLocation) || getStoredLocation();
    var lat = (loc && isFinite(loc.lat)) ? loc.lat : DEFAULT_LAT;
    var lng = (loc && isFinite(loc.lng)) ? loc.lng : DEFAULT_LNG;
    return lng + ',' + lat;
  }

  function searchLocation(query) {
    if (!searchSessionToken) searchSessionToken = generateUUID();
    var lang = isArabic() ? 'ar' : 'en';
    var url = 'https://api.mapbox.com/search/searchbox/v1/suggest'
      + '?q=' + encodeURIComponent(query)
      + '&access_token=' + MAPBOX_TOKEN
      + '&session_token=' + searchSessionToken
      + '&language=' + lang
      + '&types=country%2Cregion%2Cdistrict%2Cpostcode%2Clocality%2Cplace%2Cneighborhood%2Caddress%2Cpoi%2Cstreet%2Ccategory'
      + '&proximity=' + getProximity()
      + '&limit=10';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) { renderResults(data.suggestions || []); })
      .catch(hideResults);
  }

  function renderResults(suggestions) {
    searchResults.innerHTML = '';

    if (!suggestions || suggestions.length === 0) {
      searchResults.innerHTML = '<div class="geo-search-results__empty">No results found</div>';
      searchResults.style.display = 'block';
      return;
    }

    suggestions.forEach(function (item) {
      const el = document.createElement('div');
      el.className = 'geo-search-results__item';

      const nameEl = document.createElement('div');
      nameEl.className = 'geo-search-results__item-name';
      nameEl.textContent = item.name || item.full_address || '';
      el.appendChild(nameEl);

      const addressText = item.place_formatted || item.full_address || '';
      if (addressText && addressText !== nameEl.textContent) {
        const addressEl = document.createElement('div');
        addressEl.className = 'geo-search-results__item-address';
        addressEl.textContent = addressText;
        el.appendChild(addressEl);
      }

      el.addEventListener('mousedown', function (e) {
        e.preventDefault();
        retrieveSuggestion(item);
        searchInput.blur(); // dismiss the on-screen keyboard now that a suggestion is chosen
      });
      searchResults.appendChild(el);
    });

    searchResults.style.display = 'block';
  }

  function retrieveSuggestion(suggestion) {
    var url = 'https://api.mapbox.com/search/searchbox/v1/retrieve/' + encodeURIComponent(suggestion.mapbox_id)
      + '?access_token=' + MAPBOX_TOKEN
      + '&session_token=' + searchSessionToken;

    // Generate a new session token for the next search session
    searchSessionToken = generateUUID();

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var feature = data.features && data.features[0];
        if (!feature) return;
        var coords = feature.properties && feature.properties.coordinates;
        var lat = coords ? coords.latitude  : feature.geometry.coordinates[1];
        var lng = coords ? coords.longitude : feature.geometry.coordinates[0];
        map.flyTo({ center: [lng, lat], zoom: 15 });
        marker.setLngLat([lng, lat]);

        // Use the POI name/full address from the retrieve response rather than
        // reverse geocoding — reverse geocoding only knows administrative
        // context ("Dubai") and loses the actual place name ("The Dubai Mall").
        // City/country/region context, however, is sourced from v6 reverse
        // geocode in both languages, for parity with the GPS/pin-drop path;
        // the retrieve response's own (English-only) context is kept only as
        // a fallback for when the reverse-geocode calls below fail.
        var props = feature.properties || {};
        var ctx = props.context || {};
        var poiNameEn = props.name || props.name_preferred || suggestion.name || '';
        var poiNameAr = (suggestion.name_local && suggestion.name_local.ar) || poiNameEn;
        var fullAddressEn = props.full_address || props.place_formatted || '';
        var cityEnFallback = (ctx.place && ctx.place.name) || '';
        var countryEnFallback = (ctx.country && ctx.country.name) || '';
        var regionEnFallback = (ctx.region && ctx.region.name) || '';
        var regionCodeFallback = (ctx.region && ctx.region.region_code_full) || '';

        Promise.all([fetchAddress(lat, lng, 'en'), fetchAddress(lat, lng, 'ar')])
          .then(function (res) {
            var en = res[0], ar = res[1];
            setPendingLocation(lat, lng, {
              display_en: fullAddressEn,
              display_ar: ar.fullAddress || fullAddressEn,
              city_en: poiNameEn || en.city,
              city_ar: poiNameAr || ar.city || en.city,
              country_en: en.country,
              country_ar: ar.country || en.country,
              city_context_en: en.city,           city_context_ar: (ar.city || en.city),
              country_context_en: en.country,     country_context_ar: (ar.country || en.country),
              region_context_en: en.region,        region_context_ar: (ar.region || en.region),
              region_code: en.regionCode || ar.regionCode || ''
            }, isArabic() ? (poiNameAr || poiNameEn) : poiNameEn,
               isArabic() ? (ar.country || en.country) : en.country);
          })
          .catch(function () {
            setPendingLocation(lat, lng, {
              display_en: fullAddressEn,
              display_ar: fullAddressEn,
              city_en: poiNameEn || cityEnFallback,
              city_ar: poiNameAr || cityEnFallback,
              country_en: countryEnFallback,
              country_ar: countryEnFallback,
              city_context_en: cityEnFallback,        city_context_ar: cityEnFallback,
              country_context_en: countryEnFallback,  country_context_ar: countryEnFallback,
              region_context_en: regionEnFallback,    region_context_ar: regionEnFallback,
              region_code: regionCodeFallback
            }, isArabic() ? (poiNameAr || poiNameEn) : poiNameEn, countryEnFallback);
          });

        // Combine the POI/place name with its address subtext — full_address alone
        // (the old behaviour) drops the actual place name for POIs, e.g. showing just
        // "- 7 1C St, Emirate of Ras Al Khaimah, United Arab Emirates" with no
        // indication the place is "Al Juwais Street".
        var searchDisplayName = poiNameEn || suggestion.name || '';
        var searchSubtext = props.place_formatted || fullAddressEn || '';
        searchInput.value = (searchSubtext && searchSubtext !== searchDisplayName)
          ? (searchDisplayName ? searchDisplayName + ', ' + searchSubtext : searchSubtext)
          : (searchDisplayName || searchSubtext);
        hideResults();
      })
      .catch(hideResults);
  }

  function hideResults() {
    searchResults.style.display = 'none';
    searchResults.innerHTML = '';
  }

  // ── Location state updaters ──────────────────────────────────────────────
  // bilingualAddresses: { display_en, display_ar, city_en, city_ar, country_en, country_ar }
  // city / country: current-locale values for immediate display
  // isPlaceholder: true only for the synchronous "Detecting location..." sentinel set at
  // the start of getCurrentLocation() — keeps Confirm disabled so it can't be clicked
  // while a real address is still resolving (which previously let a stale/placeholder
  // value get saved and written into the header bar).
  function setPendingLocation(lat, lng, bilingualAddresses, city, country, isPlaceholder) {
    var bi = bilingualAddresses || {};
    var displayAddress = isArabic()
      ? (bi.display_ar || bi.display_en || '')
      : (bi.display_en || bi.display_ar || '');
    pendingLocation = {
      lat: lat, lng: lng,
      address: displayAddress,
      city: city, country: country,
      display_en: bi.display_en || '',
      display_ar: bi.display_ar || '',
      city_en: bi.city_en || (isArabic() ? '' : city),
      city_ar: bi.city_ar || (isArabic() ? city : ''),
      country_en: bi.country_en || (isArabic() ? '' : country),
      country_ar: bi.country_ar || (isArabic() ? country : ''),
      city_context_en: bi.city_context_en || '',
      city_context_ar: bi.city_context_ar || '',
      country_context_en: bi.country_context_en || '',
      country_context_ar: bi.country_context_ar || '',
      region_context_en: bi.region_context_en || '',
      region_context_ar: bi.region_context_ar || '',
      region_code: bi.region_code || ''
    };
    currentName.textContent = city || displayAddress || 'Unknown location';
    currentAddress.textContent = displayAddress;
    if (confirmBtn) confirmBtn.disabled = !!isPlaceholder;
    syncBoxVisibility();
  }

  function setConfirmedBox(loc) {
    var city = isArabic() ? (loc.city_ar || loc.city) : (loc.city_en || loc.city);
    var address = isArabic() ? (loc.display_ar || loc.address) : (loc.display_en || loc.address);
    selectedName.textContent = city || address || 'Unknown location';
    selectedAddress.textContent = address;
  }

  // ── localStorage helpers ─────────────────────────────────────────────────
  function getStoredLocation() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.savedAt || (Date.now() - parsed.savedAt) > MAX_LOCATION_AGE_MS) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveLocation(loc) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, loc, { savedAt: Date.now() })));
    } catch (e) {}
  }

  // ── Bar text update ──────────────────────────────────────────────────────
  function updateBar(loc) {
    if (!barLocation) return;
    var city    = isArabic() ? (loc.city_ar    || loc.city)    : (loc.city_en    || loc.city);
    var country = isArabic() ? (loc.country_ar || loc.country) : (loc.country_en || loc.country);
    barLocation.textContent = [city, country].filter(Boolean).join(', ');
  }

  // ── On page load: restore bar or open drawer ─────────────────────────────
  (function initOnLoad() {
    const stored = getStoredLocation();
    if (stored) {
      updateBar(stored);
    } else {
      setTimeout(openDrawer, 600);
    }
  })();

  // ── Event listeners ──────────────────────────────────────────────────────
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (locationHintRetry) {
    locationHintRetry.addEventListener('click', function () {
      hideLocationHint();
      getCurrentLocation();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounceTimer);
      const query = searchInput.value.trim();
      if (query.length < 3) { hideResults(); return; }
      searchDebounceTimer = setTimeout(function () { searchLocation(query); }, 350);
    });

    searchInput.addEventListener('blur', function () {
      setTimeout(hideResults, 150);
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      if (isDesktopViewport()) return; // keyboard-dismiss is only relevant on the non-drawer (<=768px) layout
      searchInput.blur(); // just close the keyboard; user taps Confirm themselves
    });
  }

  if (selectedBox) {
    selectedBox.addEventListener('click', function () {
      if (!confirmedLocation || !map) return;
      map.flyTo({ center: [confirmedLocation.lng, confirmedLocation.lat], zoom: 15 });
      marker.setLngLat([confirmedLocation.lng, confirmedLocation.lat]);
      var city    = isArabic() ? (confirmedLocation.city_ar    || confirmedLocation.city)    : (confirmedLocation.city_en    || confirmedLocation.city);
      var country = isArabic() ? (confirmedLocation.country_ar || confirmedLocation.country) : (confirmedLocation.country_en || confirmedLocation.country);
      setPendingLocation(confirmedLocation.lat, confirmedLocation.lng, confirmedLocation, city, country);
    });
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (!pendingLocation) return;
      confirmedLocation = pendingLocation;
      saveLocation(confirmedLocation);
      setConfirmedBox(confirmedLocation);
      updateBar(confirmedLocation);
      syncBoxVisibility();
      if (searchInput) searchInput.value = '';
      hideResults();
      closeDrawer();
      window.dispatchEvent(new CustomEvent('med7:location-saved', {
        detail: { lat: confirmedLocation.lat, lng: confirmedLocation.lng }
      }));
    });
  }
})();
